/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kreditorennummer1Inputs */

const de__field_kreditorennummer1 = /** @type {(inputs: _Field_Kreditorennummer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreditorennummer`)
};

/**

* @param {_Field_Kreditorennummer1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kreditorennummer1 = /** @type {((inputs?: _Field_Kreditorennummer1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kreditorennummer1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kreditorennummer1(inputs)
});
export { _field_kreditorennummer1 as "_field_kreditorenNummer" }